import baseConfig from '@config/base.config';
import localesConfig from '@config/locales.config';
import productConfig from '@config/product.config';
import cookieUtils from '@utils/cookie.utils';

export default {
    hasLanguageKey(key: string) {
        return localesConfig.some(item => item.key === key);
    },

    /**
     * .com域名下默认语言按浏览器语言
     */
    getDefaultLocale() {
        const defaultLocale: any = localesConfig.find(item => item.isDefault);
        const href = window.location.href;
        let locale = defaultLocale.key;
        href.includes('.com') ? (locale = getNavigatorLanguage('en')) : (locale = 'jp');
        const language: string = (productConfig as any)[locale]?.language;
        return this.hasLanguageKey(language) ? language : defaultLocale;
    },

    getLanguage() {
        // 用户登录并且本地已存储i18nkey
        const { ACCOUNT_I18N, ACCOUNT_TOKEN } = baseConfig;
        const settingLan = localStorage.getItem(ACCOUNT_I18N) || cookieUtils.getItem(ACCOUNT_I18N);
        let language = this.getDefaultLocale();
        if (
            Boolean(localStorage.getItem(ACCOUNT_TOKEN) || cookieUtils.getItem(ACCOUNT_TOKEN)) &&
            this.hasLanguageKey(settingLan)
        ) {
            language = settingLan;
        }
        return language;
    },

    updateLanguage(locale: string) {
        // const i18n = useI18n();
        // if (i18n.locale.value === locale) return;
        // const language = this.hasLanguageKey(locale) ? locale : this.getDefaultLocale();
        // i18n.locale.value = language;
        // this.updateStorageLanguage(language);
    },

    updateStorageLanguage(i18n) {
        const { ACCOUNT_I18N } = baseConfig;
        localStorage.setItem(ACCOUNT_I18N, i18n);
    },

    removeStorageLanguage() {
        const { ACCOUNT_I18N } = baseConfig;
        localStorage.removeItem(ACCOUNT_I18N);
    }
};

function getNavigatorLanguage(defaultKey: string) {
    const mapping: any = {
        zh: 'zh',
        ja: 'jp',
        en: 'en'
    };
    const key = window.navigator.language.toLocaleLowerCase().substring(0, 2);
    if (mapping?.[key]) {
        return mapping[key];
    }
    return mapping[defaultKey];
}
